// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2T4qv","selected":"Chip_selected__2o8Uk"};